import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { PathNames } from 'constants/General'

const BackButton = () => {
  const [canNavigate, setCanNavigate] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location?.pathname) {
      shouldNavigate(location?.pathname)
    }
  }, [location.pathname])

  const handleBackClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    navigate(-1)
  }

  const shouldNavigate = (path: string) => {
    if (path.indexOf('/business/') > -1) {
      setCanNavigate(false)
    } else {
      switch (path) {
        case '/':
        case '/home':
        case '/marketplace':
        case '/business':
        case PathNames.LOGIN:
          setCanNavigate(false)
          break

        default:
          setCanNavigate(true)
          break
      }
    }
  }

  return canNavigate ? (
    <div
      className="cursor-pointer bg-offWhite w-10 h-10 rounded-full flex items-center justify-center"
      onClick={e => handleBackClick(e)}
    >
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="#0A1628"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 5.00001H3.41401L6.70701 1.70701C7.09801 1.31601 7.09801 0.684006 6.70701 0.293006C6.31601 -0.0979941 5.68401 -0.0979941 5.29301 0.293006L0.293006 5.29301C-0.0979941 5.68401 -0.0979941 6.31601 0.293006 6.70701L5.29301 11.707C5.48801 11.902 5.74401 12 6.00001 12C6.25601 12 6.51201 11.902 6.70701 11.707C7.09801 11.316 7.09801 10.684 6.70701 10.293L3.41401 7.00001H15C15.553 7.00001 16 6.55201 16 6.00001C16 5.44801 15.553 5.00001 15 5.00001Z"
          fill="#0A1628"
        />
      </svg>
    </div>
  ) : (
    <></>
  )
}

export default BackButton
